export default __webpack_public_path__ + "static/media/share-modal.de1776b0.svg";